<template>
  <div>
    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="detail-header">
      <div class="clearfix">
        <a class="img-back white pull-left" style="margin-left:0;padding-left:15px;" href="javascript:window.history.go(-1)">返回</a>
        <!-- <router-link class="pull-right white" :to="{'path':'/teacher/edit/' + teacherId}" v-if='cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2' v-tap>编辑</router-link> -->
        <a class="pull-right white"  v-if='cookie_login_data.jobId == 1 && info.jobId != 1' @click.prevent="updTeacherMsg()">保存</a>
         <a v-else></a>
      </div>
      <div class="text-center">
        <span class="block img-wrap big"><img :src="info.teacherIcon ? (info.baseAcessPath + info.teacherIcon) : img_default" width="100%"></span>
        <span class="font-16 block margin-15">{{ info.teacherName }}</span>
      </div>
    </div>

    <div>
      <ul class="list-group-item primary">
        <li class="clearfix list-group text-center padding-15">
          <div class="col-xs-6"><a class="block" v-bind:href="'tel:' + info.phoneNum"><i class="img-call"></i><span class="block gray">呼叫</span></a></div>
          <div class="col-xs-6 line-y"><a class="block" v-bind:href="'sms:' + info.phoneNum"><i class="img-message"></i><span class="block gray">信息</span></a></div>
        </li>
      </ul>
    </div>
    <div>
      <ul class="list-group-item tinny">
         <li class="list-group">
            <div class="liner"></div>
            <label class="clearfix group-txt forselect" for="zhiwu" v-bind:class="{ 'img-more' : isUpdateJob }">
              <span class="pull-left">职务：</span>
              <span class="pull-right margin-x-15 gray font-12" @click="isHideJob = !isUpdateJob">{{info.jobName}}</span>
              <span class="selectbar" v-bind:class="{ 'hide' : !isUpdateJob}">
                <!-- <select id="zhiwu" v-model="info.jobName" @change="positionSelected($event)">
                  <option value="管理员" id="2">管理员</option>
                  <option value="老师" id="3">老师</option>
                  <option value="保育员" id="8">保育员</option>
                  <option value="兼职老师" id="9">兼职老师</option>
                </select> -->
               <!--  <select id="zhiwu"  @change="selectedJob()">
                  <option v-for="item in jobList" :value="item.jobId" :id="item.jobId">{{item.jobName}}</option>
                </select> -->
              </span>
            </label>
          </li>
       <!--  <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix  group-txt">
            <span class="pull-left">职务：</span>
            <span class="pull-right gray">{{ info.jobName }}</span>
          </div>
        </li> -->
        <li class="list-group hide">
          <div class="liner"></div>
          <div class="clearfix  group-txt">
            <span class="pull-left">群组：</span>
            <span class="pull-right orange font 12" v-if="info.className == '还没加入班级！'">{{ info.className }}</span>
            <span class="pull-right gray" v-for="item in info.classList" v-else>{{ item.className }}&nbsp;</span>
          </div>
        </li>
        <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix group-txt">
            <span class="pull-left">园点:</span>
            <span class="pull-right gray">{{ info.curcheName }}</span>
          </div>
        </li>
        <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix group-txt">
            <span class="pull-left">绑定手机号：</span>
            <a class="pull-right font-14" b-bind:href="'tel:' + info.phoneNum">{{ info.phoneNum }}</a>
          </div>
        </li>
        <li class="list-group">
          <div class="liner"></div>
          <div class="clearfix  group-txt">
            <span class="pull-left">生日：</span>
            <span class="pull-right gray">{{ info.teacherBirthdayString }}</span v-if="info.teacherBirthdayString">
            <span class="pull-right gray ">还未填写生日</span v-else>
          </div>
        </li>
      </ul>

      <ul class="list-group-item tinny" v-if='cookie_login_data.jobId == 1 && info.jobId != 1'>
        <li class="list-group" v-if="cookie_login_data.teacherId != teacherId">
          <span class="group-txt text-center" @click="isHideDeleteDialog = false">删除老师</span>
        </li>
      </ul>
    </div>
    </mt-loadmore>

    <div class="maskdiv" v-show="!isHideDeleteDialog" @click="isHideDeleteDialog = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p class="padding-15">您确定要删除该老师吗?</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
            <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deleteTeacherMsg()">删除</a></div>
            <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideDeleteDialog = true">不删除</a></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择职务 -->
    <div class="maskdiv" v-show="!isHideJob" @click="isHideJob = true">
      <div class="slider" @click.stop>
        <strong class="tit">选择职务</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in jobList">
            <li @click="info.jobName = item.jobName, info.jobId = item.jobId, isHideJob = true">
              <div class="clearfix group-link"><span class="pull-left">{{item.jobName}}</span>
              <template v-if="item.jobName == info.jobName">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_teacher_by_id_para: service.setPara('getTeacherById'),
      upd_teacher_para: service.setPara('updateTeacher'),
      delete_teacher_para: service.setPara('deleteTeacher'),
      info: {},
      teacherNameList: [],
      teacherId: 0,
      isHideDeleteDialog: true,
      isUpdateJob: false,
      isHideJob: true,
      jobList: [{jobName: '管理员', jobId: 2}, {jobName: '老师', jobId: 3}]
    }
  },
  mounted: function () {
    this.teacherId = this.$route.params.teacherId
    this.getTeacherMsg()
  },
  methods: {
    ...mapMutations([
      'clearTeachers',
      'deleteTeacher'
    ]),
    loadTop (id) {
      this.getTeacherMsg()
      this.$refs.loadmore.onTopLoaded(id)
    },
    // positionSelected: function (obj) {
    //   for (var i = 0; i < obj.currentTarget.length; i++) {
    //     if (obj.currentTarget[i].selected) {
    //       this.info.jobId = parseInt(obj.currentTarget[i].id)
    //     }
    //   }
    // },
    getTeacherMsg: function () {
      this.get_teacher_by_id_para.curcheId = this.cookie_login_data.curcheId
      this.get_teacher_by_id_para.teacherId = this.teacherId
      let obj = {context: this, para: this.get_teacher_by_id_para, successFun: (response) => {
        this.info = response.data

        if (this.cookie_login_data.jobId == 1 && this.info.jobId != 1) {
          this.isUpdateJob = true
        }
        if ((this.cookie_login_data.teacherId == this.teacherId && this.cookie_login_data.jobId == 1) || this.info.jobId == 1) {
          $('#zhiwu option[value="老师"]').remove()
        }
      }}
      service.request(obj)
    },
    deleteTeacherMsg: function () {
      this.delete_teacher_para.curcheId = this.cookie_login_data.curcheId
      this.delete_teacher_para.teacherId = this.teacherId
      let obj = {context: this, para: this.delete_teacher_para, successFun: (response) => {
        Toast('删除成功')
        this.$store.dispatch('deleteTeacher', this.teacherId)
        window.history.go(-1)
      }}
      service.request(obj)
    },
    updTeacherMsg: function () {
      this.upd_teacher_para.curcheId = this.cookie_login_data.curcheId
      this.upd_teacher_para.teacherId = this.teacherId
      this.upd_teacher_para.jobId = this.info.jobId
      let obj = {context: this, para: this.upd_teacher_para, successFun: (response) => {
        Toast('编辑成功')
        this.$store.dispatch('clearTeachers')
        window.history.go(-1)
      }}
      service.request(obj)
    }
  }
}

</script>



// WEBPACK FOOTER //
// TeacherDetail.vue?2ab8ded5